import * as React from "react";
import RadioButton from "../../../generic/radioButton";
import EdButton from "../../../generic/edButton";
import "../../../../assets/scss/components/toc/orderPlacement/opInsufficientFunds/opInsufficientFunds.scss";
import { IListObj } from "../../../types/genericTypes";

export interface IOpInsufficientFundsProps {
	currentValue: string; // Current value
	orderValue: string; // SIP / Order value
	isSip?: boolean; // if true, then 'SIP Value' else 'Order value'
	radioButtonList: Array<IListObj>; // list to create radio buttons
	onProceed: (selectedValue: string | number) => void; //
}

const OpInsufficientFunds: React.FC<IOpInsufficientFundsProps> = props => {
	const [selectedRadio, setSelectedRadio] = React.useState<number | string>(props.radioButtonList[0].value);

	return (
		<div className="op_insufficient_funds">
			<i className="edel-icon-insufficient-funds" />
			<p className="red_text">You have insufficient funds to place this order.</p>
			<p className="red_text">Please select next step</p>
			<p className="current_balance">Current Balance: {props.currentValue}</p>
			<p className="order_value">
				{props.isSip ? "SIP" : "Order"} Value: {props.orderValue}
			</p>
			<div className="radio_btns_outer">
				<div className="radio_btns_inner">
					{props.radioButtonList.map(radio => (
						<div className="radio_btn" key={radio.value}>
							<RadioButton
								list={radio}
								name="insufficient-funds"
								selected={selectedRadio}
								onChange={() => setSelectedRadio(radio.value)}
							/>
						</div>
					))}
				</div>
			</div>
			<EdButton value="Proceed" onClick={() => props.onProceed(selectedRadio)} btnTyp="primary" className="proceed_btn" />
		</div>
	);
};

export default OpInsufficientFunds;
